/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_No_Upcoming_PaymentInputs */

const en_plan_no_upcoming_payment = /** @type {(inputs: Plan_No_Upcoming_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No upcoming payment`)
};

const es_plan_no_upcoming_payment = /** @type {(inputs: Plan_No_Upcoming_PaymentInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay próximo pago`)
};

/**
* | output |
* | --- |
* | "No upcoming payment" |
*
* @param {Plan_No_Upcoming_PaymentInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const plan_no_upcoming_payment = /** @type {((inputs?: Plan_No_Upcoming_PaymentInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_No_Upcoming_PaymentInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_plan_no_upcoming_payment(inputs)
	return en_plan_no_upcoming_payment(inputs)
});